import { render, staticRenderFns } from "./icon-svg-info.vue?vue&type=template&id=ccfe7b9a&"
import script from "./icon-svg-info.vue?vue&type=script&lang=js&"
export * from "./icon-svg-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports